import { createAction } from '@reduxjs/toolkit';

import type { Project, TeamInvitation, TeamSettings, UserProfile, Workspace } from 'js/src/client';
import { ACCOUNT_ACTIONS } from 'js/src/data/account/account-types';
import type { ImmutableMap } from 'js/src/libs/consts';

export const storeWorkspaces = createAction<{
    workspaces: Immutable.List<ImmutableMap<Workspace>>;
}>(ACCOUNT_ACTIONS.STORE_WORKSPACES);

export const updateWorkspace = createAction<{
    workspace: ImmutableMap<Workspace>;
    workspaceId: number;
}>(ACCOUNT_ACTIONS.UPDATE_WORKSPACE);

export const storeWorkspaceMembers = createAction<{
    workspaceId: number;
    members: Array<UserProfile>;
}>(ACCOUNT_ACTIONS.STORE_WORKSPACE_MEMBERS);

export const storeTeamMembers = createAction<{
    members: UserProfile[];
}>(ACCOUNT_ACTIONS.STORE_TEAM_MEMBERS);

export const updateTeamMember = createAction<{
    userId: number;
    key: string[];
    value: unknown;
}>(ACCOUNT_ACTIONS.UPDATE_TEAM_MEMBER);

export const storeUserProfile = createAction<UserProfile>(ACCOUNT_ACTIONS.STORE_USER_PROFILE);

export const storeProjects = createAction<{
    projects: Project[];
}>(ACCOUNT_ACTIONS.STORE_PROJECTS);

export const deleteProject = createAction<{
    projectId: number;
}>(ACCOUNT_ACTIONS.DELETE_PROJECT);

export const setProjectLoadingIndicator = createAction<{
    isLoading: boolean;
}>(ACCOUNT_ACTIONS.SET_PROJECTS_LOADING_INDICATOR);

export const storeTeamSettings = createAction<TeamSettings>(ACCOUNT_ACTIONS.STORE_TEAM_SETTINGS);

export const updateMaxTeamSize = createAction<{
    maxTeamSize: number;
}>(ACCOUNT_ACTIONS.UPDATE_MAX_TEAM_SIZE);

/**
 * Invitations
 */
export const setInvitationsLoading = createAction<{
    isLoading: boolean;
}>(ACCOUNT_ACTIONS.SET_INVITATIONS_LOADING);

export const storeInvitations = createAction<{
    invitations: Immutable.List<ImmutableMap<TeamInvitation>>;
}>(ACCOUNT_ACTIONS.STORE_INVITATIONS);

export const deleteInvitationAction = createAction<{
    id: number;
}>(ACCOUNT_ACTIONS.DELETE_INVITATION);

export const createInvitationsAction = createAction<{
    invitations: TeamInvitation[];
}>(ACCOUNT_ACTIONS.CREATE_INVITATIONS);
